module.exports = __webpack_public_path__ + "img/finish@3x.1bb51933.png";